// app/permissionSlice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Permission, PermissionApiResponse } from "../types/roleTypes";
import { fetchPermissionList } from "../services/permissionServices";

interface PermissionState {
  permissions: Permission[];
  loading: boolean;
  error: string | null;
}

const initialState: PermissionState = {
  permissions: [],
  loading: false,
  error: null,
};

export const fetchAllPermissions = createAsyncThunk<PermissionApiResponse>(
  "permission/fetchAll",
  async (_, thunkAPI) => {
    try {
      const res = await fetchPermissionList();
      return res;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.message || "Failed to fetch permissions");
    }
  }
);


const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload.data;
        state.loading = false;
      })
      .addCase(fetchAllPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default permissionSlice.reducer;
